import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import GameProp from '../propTypes/gameProp';
import Progress from '../../academy/list/enrolledItem/Progress';
import { GAME_TYPE } from '../../../services/utilityFunctions';
import Anchor from '../../../commonComponents/Anchor';

function ChallengeListItem({ t, game }) {
  const isCandidates =
    game.gameType && game.gameType.type === GAME_TYPE.CANDIDATES;

  return (
    <div className="dashboard-challenge-item">
      <img
        src={game.image ? game.image.thumb : ''}
        alt="challenge preview"
        className="challenge-image"
      />
      <h6 className="challenge-name">{game.name}</h6>
      {isCandidates ? (
        <div>{`${game.candidates || 0} | 6`}</div>
      ) : (
        <Progress progress={game.progress < 0 ? 0 : game.progress} />
      )}
      {game?.challenges?.isViewSimplified !== true && (
        <Anchor
          href={`/challenges/${game._id}`}
          className="btn m-btn--pill btn-dynamic"
        >
          {t('inbox_game_timeline')}
        </Anchor>
      )}
    </div>
  );
}

ChallengeListItem.propTypes = {
  t: PropTypes.func.isRequired,
  game: PropTypes.shape(GameProp.propType).isRequired,
};

export default translate(ChallengeListItem);
